import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import LoginPageRaw from '../pages/Login';
import Billing from '../pages/Billing';
import OnboardingRaw from '../pages/Onboarding';
import Verify from '../pages/Verify';
import ExternalRedirect from '../components/ExternalRedirect';
import EmployeePortal from '../pages/EmployeePortal';
import AddPayrollV2 from '../pages/AddPayrollV2';
import CartV2 from '../pages/CartV2';
import Checkout from '../pages/Checkout';
import HelpAutoPayroll from '../pages/HelpAutoPayroll';
import ResetPassword from '../pages/ResetPassword';
import AcceptInvite from '../pages/AcceptInvite';

// Cast .js pages that take props so TypeScript accepts the props
const LoginPage = LoginPageRaw as unknown as React.ComponentType<{
  onLogin: (t: string, email?: string) => void;
}>;
const Onboarding = OnboardingRaw as unknown as React.ComponentType<{
  onComplete: () => void;
}>;

type PublicRoutesProps = {
  token: string | null;
  onLogin: (token: string, email?: string) => void;
};

/**
 * Routes that work WITHOUT authentication.
 * Returns a fragment of <Route> elements to drop inside the top-level <Routes>.
 */
export function publicRoutes({ token, onLogin }: PublicRoutesProps): React.ReactNode {
  return (
    <>
      <Route path="/login" element={token ? <Navigate to="/" replace /> : <LoginPage onLogin={onLogin} />} />
      <Route path="/billing" element={<Billing />} />
      <Route path="/register" element={<Onboarding onComplete={() => window.location.replace('/dashboard')} />} />
      <Route path="/verify-code" element={<Verify />} />
      <Route path="/pricing" element={<ExternalRedirect to="https://www.getnovala.com/pricing" />} />
      <Route path="/employee-portal" element={<EmployeePortal />} />
      <Route path="/pricing-v2" element={<ExternalRedirect to="https://www.getnovala.com/pricing" />} />
      <Route path="/add-payroll" element={<AddPayrollV2 />} />
      <Route path="/add-payroll-v2" element={<AddPayrollV2 />} />
      <Route path="/cart-v2" element={<CartV2 />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/cart" element={<CartV2 />} />
      <Route path="/help/auto-payroll" element={<HelpAutoPayroll />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite/:token" element={<AcceptInvite />} />
    </>
  );
}
